import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the chat state domain
 */

const selectChatDomain = state => state.chat || initialState;

const makeSelectLoading = () => createSelector(selectChatDomain, subState => subState.loading);

const makeSelectInboxStatistics = () =>
  createSelector(selectChatDomain, subState => subState.inbox.statistics);

const makeSelectCustomFilter = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.customFilter);

const makeSelectConversationListVisitors = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.visitors);

const makeSelectConversationListBot = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.bot);

const makeSelectInboxPusherChannels = () =>
  createSelector(selectChatDomain, subState => subState.inbox.pusherChannels);

const makeSelectInboxSender = () =>
  createSelector(selectChatDomain, subState => subState.inbox.sender);

const makeSelectConversationListVisitorNext = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.visitorNext);

const makeSelectConversationListBotNext = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.botNext);

const makeSelectConversationListLoading = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.loading);

const makeSelectConversationListFiltering = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.filtering);

const makeSelectConversationListError = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.error);

const makeSelectConversationDetailMessages = () =>
  createSelector(selectChatDomain, subState => subState.conversationDetail.messages);

const makeSelectConversationDetailLastMessagePos = () =>
  createSelector(selectChatDomain, subState => subState.conversationDetail.lastMessagePos);

const makeSelectConversationDetailConversationId = () =>
  createSelector(selectChatDomain, subState => subState.conversationDetail.conversationId);

const makeSelectConversationDetailDetails = () =>
  createSelector(selectChatDomain, subState => subState.conversationDetail.details);

const makeSelectConversationDetailLoading = () =>
  createSelector(selectChatDomain, subState => subState.conversationDetail.loading);

const makeSelectNewConversationLoading = () =>
  createSelector(selectChatDomain, subState => subState.conversationDetail.loadingNewConversation);

const makeSelectConversationDetailError = () =>
  createSelector(selectChatDomain, subState => subState.conversationDetail.error);

const makeSelectTeamAgents = () =>
  createSelector(selectChatDomain, subState => subState.team.users);

const makeSelectTeamAgentsLoading = () =>
  createSelector(selectChatDomain, subState => subState.team.loading);

const makeSelectConversationParticipants = () =>
  createSelector(selectChatDomain, subState => subState.conversationDetail.participants);

const makeSelectAddingNewMembers = () =>
  createSelector(selectChatDomain, subState => subState.addNewMember.loading);

const makeSelectCurrentConversation = () =>
  createSelector(selectChatDomain, subState => subState.currentConversation);

const makeSelectUserStatus = () =>
  createSelector(selectChatDomain, subState => subState.userStatus);

const makeSelectSendingMessages = () =>
  createSelector(selectChatDomain, subState => subState.conversationDetail.sendingMessages);

const makeSelectReadTime = () =>
  createSelector(
    selectChatDomain,
    subState => subState.conversationDetail.details.visitorLastReadTime
  );

const makeSelectDeliveredTime = () =>
  createSelector(
    selectChatDomain,
    subState => subState.conversationDetail.details.visitorLastDeliveredTime
  );

const makeSelectIsUpdateConversationList = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.updateConversationList);

const makeSelectCannedMessagesList = () =>
  createSelector(selectChatDomain, subState => subState.cannedMessages.data);
const makeSelectIsCannedMessagesLoading = () =>
  createSelector(selectChatDomain, subState => subState.cannedMessages.isLoading);
const makeSelectIsCannedMessagesSaving = () =>
  createSelector(selectChatDomain, subState => subState.cannedMessages.isSaving);
const makeSelectCannedMessageError = () =>
  createSelector(selectChatDomain, subState => subState.cannedMessages.error);
const makeSelectEditorHasContent = () =>
  createSelector(selectChatDomain, subState => subState.editorHasContent);
const makeSelectHasNewMessages = () =>
  createSelector(selectChatDomain, subState => subState.cannedMessages.newMessage);
const makeSelectHasSendMessage = () =>
  createSelector(selectChatDomain, subState => subState.cannedMessages.hasSendMessage);
const makeSelectVisitor = () =>
  createSelector(selectChatDomain, subState => subState.conversationDetail.visitor);

const makeSelectZendeskInboxActiveTab = () =>
  createSelector(selectChatDomain, subState => subState.zendeskInboxActiveTab);
const makeSelectIsKnowledgeBaseArticlesLoading = () =>
  createSelector(selectChatDomain, subState => subState.knowledgeBaseArticles.loading);
const makeSelectIsKnowledgeBaseArticles = () =>
  createSelector(selectChatDomain, subState => subState.knowledgeBaseArticles.data);
const makeSelectConnectedApps = () =>
  createSelector(selectChatDomain, subState => subState.connectedApps);

const makeSelectConversationsRead = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.logs.conversationsRead);

const makeSelectSelectedFilters = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.logs.selectedFilters);

const makeSelectServiceCloudActiveTab = () =>
  createSelector(selectChatDomain, subState => subState.serviceCloud.tab);

const makeSelectIsServiceCloudArticlesLoading = () =>
  createSelector(selectChatDomain, subState => subState.serviceCloud.articles.loading);

const makeSelectIsServiceCloudArticles = () =>
  createSelector(selectChatDomain, subState => subState.serviceCloud.articles.data);
const makeSelectServiceCloudCaseCreationLoading = () =>
  createSelector(selectChatDomain, subState => subState.serviceCloud.caseCreation.loading);
const makeSelectIsVisitorBlockedLoading = () =>
  createSelector(selectChatDomain, subState => subState.blockVisitor.loading);

const makeSelectIsVisitorBlocked = () =>
  createSelector(selectChatDomain, subState => subState.blockVisitor.data.isBlocked);

const makeSelectIsVisitorBlockModalOpen = () =>
  createSelector(selectChatDomain, subState => subState.blockVisitor.data.showModal);
const makeSelectTags = () => createSelector(selectChatDomain, subState => subState.tags.data);

const makeSelectIsHighlightsSetup = () =>
  createSelector(selectChatDomain, subState => subState.highlights.isHighlightsSetup);

const makeSelectIsHighlightsFieldsLoading = () =>
  createSelector(selectChatDomain, subState => subState.highlights.fields.loading);

const makeSelectHighlightsFieldsData = () =>
  createSelector(selectChatDomain, subState => subState.highlights.fields.data);

const makeSelectHighlightsBuilderData = () =>
  createSelector(selectChatDomain, subState => subState.highlights.builder.data);

const makeSelectHighlightsPopup = () =>
  createSelector(selectChatDomain, subState => subState.highlights.showPopup);

const makeSelectSubscriptions = () =>
  createSelector(selectChatDomain, subState => subState.subscriptions.data);

const makeSelectIntegrations = () =>
  createSelector(selectChatDomain, subState => subState.integrations.data);

const makeSelectHighlightsTemplate = () =>
  createSelector(selectChatDomain, subState => subState.highlights.templates.data);

const makeSelectHighlightsMenu = () =>
  createSelector(selectChatDomain, subState => subState.highlights.menu.data);

const makeSelectHighlightsSelectedFieldsCount = () =>
  createSelector(selectChatDomain, subState => subState.highlights.selectedFieldsCount);

const makeSelectIsHighlightsBuilderLoading = () =>
  createSelector(selectChatDomain, subState => subState.highlights.builder.loading);

const makeSelectIsHighlightsInitialSetup = () =>
  createSelector(selectChatDomain, subState => subState.highlights.isHighlightsInitialSetup);

const makeSelectConversationListFilters = () =>
  createSelector(selectChatDomain, subState => subState.conversationList.filters);

const makeSelectZendeskTicketCreationLoading = () =>
  createSelector(selectChatDomain, subState => subState.zendeskTicket.loading);

const makeSelectAttachments = () =>
  createSelector(selectChatDomain, subState => subState.attachments.data);

const makeSelectUploadProgress = () =>
  createSelector(selectChatDomain, subState => subState.attachments.uploadProgress);

export {
  makeSelectLoading,
  makeSelectInboxStatistics,
  makeSelectConversationListVisitors,
  makeSelectConversationListBot,
  makeSelectInboxPusherChannels,
  makeSelectInboxSender,
  makeSelectConversationListLoading,
  makeSelectConversationListFiltering,
  makeSelectConversationListError,
  makeSelectConversationListVisitorNext,
  makeSelectConversationListBotNext,
  makeSelectConversationDetailMessages,
  makeSelectConversationDetailConversationId,
  makeSelectConversationDetailLastMessagePos,
  makeSelectConversationDetailDetails,
  makeSelectConversationDetailLoading,
  makeSelectConversationDetailError,
  makeSelectTeamAgents,
  makeSelectTeamAgentsLoading,
  makeSelectConversationParticipants,
  makeSelectAddingNewMembers,
  makeSelectCurrentConversation,
  makeSelectUserStatus,
  makeSelectNewConversationLoading,
  makeSelectSendingMessages,
  makeSelectReadTime,
  makeSelectDeliveredTime,
  makeSelectIsUpdateConversationList,
  makeSelectCannedMessagesList,
  makeSelectIsCannedMessagesLoading,
  makeSelectIsCannedMessagesSaving,
  makeSelectCannedMessageError,
  makeSelectEditorHasContent,
  makeSelectHasNewMessages,
  makeSelectHasSendMessage,
  makeSelectVisitor,
  makeSelectCustomFilter,
  makeSelectZendeskInboxActiveTab,
  makeSelectIsKnowledgeBaseArticlesLoading,
  makeSelectIsKnowledgeBaseArticles,
  makeSelectConnectedApps,
  makeSelectConversationsRead,
  makeSelectSelectedFilters,
  makeSelectServiceCloudActiveTab,
  makeSelectIsServiceCloudArticlesLoading,
  makeSelectIsServiceCloudArticles,
  makeSelectIsVisitorBlocked,
  makeSelectIsVisitorBlockModalOpen,
  makeSelectIsVisitorBlockedLoading,
  makeSelectTags,
  makeSelectIsHighlightsSetup,
  makeSelectIsHighlightsFieldsLoading,
  makeSelectHighlightsFieldsData,
  makeSelectHighlightsBuilderData,
  makeSelectHighlightsPopup,
  makeSelectSubscriptions,
  makeSelectIntegrations,
  makeSelectHighlightsTemplate,
  makeSelectHighlightsMenu,
  makeSelectHighlightsSelectedFieldsCount,
  makeSelectIsHighlightsBuilderLoading,
  makeSelectIsHighlightsInitialSetup,
  makeSelectServiceCloudCaseCreationLoading,
  makeSelectConversationListFilters,
  makeSelectZendeskTicketCreationLoading,
  makeSelectAttachments,
  makeSelectUploadProgress,
};
